import { DashboardLayout } from '../shared/ui/DashboardLayout'
import { PageList } from '../features/pages/ui/PageList'
import { usePagesController } from '../features/pages/state/usePagesController'

export function PagesPage() {
  const controller = usePagesController()

  return (
    <DashboardLayout title="Page Management">
      <PageList
        pages={controller.pages}
        onCreate={controller.createPage}
        onUpdate={controller.updatePage}
        onDelete={controller.deletePage}
      />
    </DashboardLayout>
  )
}
